import styled           from 'styled-components';

import { themeColors,
         themeTypos,
         Typo,
         typoAsCSS    } from 'src/providers/theme/shared';



type InputPasswordLookAndFeel = {
  typo: Typo;
  normalColor: string;
  disabledColor: string;
};

const inputpassword_h48light: InputPasswordLookAndFeel = {
  typo: themeTypos.GRTSKREG_W400_S14_LH16,
  normalColor: themeColors.PrimaryBlack,
  disabledColor: themeColors.SecondaryGray4,
};

export type InputPasswordVariants = 'h48light';

export const inputpassword_variants: Map<InputPasswordVariants, InputPasswordLookAndFeel> = 
  new Map<InputPasswordVariants, InputPasswordLookAndFeel>([
    ['h48light', inputpassword_h48light],
  ]);

export const Input = styled.input<{
  isDisabled: boolean;
  lookAndFeel: InputPasswordLookAndFeel;
}>`
  width: 1px;
  flex-grow: 2;

  ${(args) => typoAsCSS(args.lookAndFeel.typo)}

  color: ${(args) => args.isDisabled ? args.lookAndFeel.disabledColor : args.lookAndFeel.normalColor};
`;
